import React, {useEffect, useState} from 'react';
import {
  Button,
  Divider, IconButton,
  ListItem,
  ListItemAvatar,
  Stack,
  Typography,
} from '@mui/material';
import List from '@mui/material/List';
import {FileUploader} from 'react-drag-drop-files';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import Tooltip from '@mui/material/Tooltip';
import FolderRoundedIcon from '@mui/icons-material/FolderRounded';


import toast from "react-hot-toast";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import {toaster} from "../../../../services/toaster";
import api from "../../../../services/api";
import {TimeFilter} from "../../../../components/Table/filters/TimeFilter";
import {FieldComponent} from "../../../../types/FieldComponent";
import CloudDownloadRoundedIcon from "@mui/icons-material/CloudDownloadRounded";
import {LoadingButton} from "@mui/lab";
import {useStateContext} from "../../../../hooks/useStateContext";
import {DeleteRounded} from "@mui/icons-material";
import {file as filesSchema} from "../../../../schema/file";
import {downloadAttachment} from "../../../../utils/downloadAttachment";

export const FileField: FieldComponent<any, any> = ({
                                                      onChange,
                                                      isActive,
                                                      value,
                                                      allValue,
                                                      hasTooltip,
                                                      disabled,
                                                      mui,
                                                      column,
                                                      schema,
                                                      mainSchema,
                                                      columnName,
                                                      addingNewEntity,
                                                      tab,
                                                    }) => {
  const [manualConfirmations, setManualConformations] = React.useState<any>([]);
  const [files, setFiles] = useState<any>([]);
  const [softLoading, setSoftLoading] = useState<boolean>(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
  const [loadingButton, setLoadingButton] = useState<any>(false);
  const {user} = useStateContext();

  const fetchManualConfirmations = async () => {
    const searchParams = new URLSearchParams({});

    api
      .get(`/service-reservation-files/${allValue?.id}`, searchParams)
      .then((result: any) => {
        setManualConformations(result);
      });
  };

  useEffect(() => {
    fetchManualConfirmations();
  }, []);

  const handleChange = (newFiles: any) => {
    const newFilesArray = [...newFiles];
    const oldFiles = [...files];
    newFilesArray.map((file: any) => {
      file.preview = URL.createObjectURL(file);
      oldFiles.push(file);
    });

    uploadFiles(newFilesArray);

    if (addingNewEntity) {
      onChange(oldFiles);
    }
  };
  const uploadFiles = (files: any) => {
    setSoftLoading(true);

    // Create a form and post it to server
    let formData = new FormData();
    files.forEach((file: any, i: any) => {
      formData.append(`file-${i}`, file);
    });

    formData.append(`column`, column?.columnName);
    formData.append(`id`, allValue?.id);
    formData.append(`schema`, JSON.stringify(schema));

    api
      .postFile(`/upload-files`, formData)
      .then((res: any) => {
        const mC = [...manualConfirmations];
        res.map((item: any) => {
          mC.push(item);
        });
        setManualConformations(mC);
      })
      .catch((error: any) => {
      })
      .finally(() => {
        setSoftLoading(false);
      });
  };

  const handleDownload = async (attachment: any) => {
    try {
      await downloadAttachment(attachment, api.getFile);
    } catch (error) {
      console.log(error);
      toaster.show({
        icon: 'error',
        message: `Error while download data`,
        intent: 'danger',
      });
    }
    return true;
  };

  return (
    <>
      <Stack
        sx={{
          opacity: softLoading ? 0.5 : 1,
          pointerEvents: softLoading ? 'none' : 'auto',
        }}
      >
        <FileUploader
          multiple={true}
          handleChange={handleChange}
          name="file"
          classes={'w-full !max-w-[100%] !min-w-[100px]'}
        />
      </Stack>
      <Divider/>
      <List
        component="div"
        aria-labelledby="Files"
        sx={{
          opacity: softLoading ? 0.5 : 1,
          pointerEvents: softLoading ? 'none' : 'auto',
          width: '100%',
        }}
      >
        {manualConfirmations.map((item: any, index: number) => {
          return (
            <>
              <ListItem
                sx={{
                  borderBottom: '1px solid #f3f3f3',
                  padding: '8px',
                }}
                key={`list-images-${index}`}
                id={`list-images-${index}`}
              >
                <ListItemAvatar
                  sx={{
                    '& .MuiAvatar-root': {
                      border: '1px solid #e1e1e1',
                      borderRadius: '4px',
                      width: '50px',
                      height: '50px',
                    },
                  }}
                >
                  {item?.type.includes('image') ? (
                    <Zoom>
                      <Tooltip title={item?.name}>
                        <Avatar src={item?.link} alt={item?.name}/>
                      </Tooltip>
                    </Zoom>
                  ) : (
                    <div
                      className={
                        'w-[50px] h-[50px] rounded-[4px] bg-[#e1e1e1] relative'
                      }
                    >
                      <FolderRoundedIcon
                        sx={{
                          color: '#b9b9b9',
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%,-50%)',
                        }}
                      />
                    </div>
                  )}
                </ListItemAvatar>
                <ListItemText
                  secondary={
                    <React.Fragment>
                      <Tooltip title={item?.name}>
                        <Typography
                          variant={'caption'}
                          color={'gray'}
                          sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: 'block'
                          }}
                        >
                          {item?.name}
                        </Typography>
                      </Tooltip>
                    </React.Fragment>
                  }
                />
                <Stack
                  direction={'row'}
                  sx={{
                    width: '100px',
                  }}
                >

                  <IconButton
                    onClick={() => {
                      handleDownload(item);
                    }}
                  >
                    <CloudDownloadRoundedIcon color={'primary'}/>
                  </IconButton>
                  {user?.id === item?.user_id && (
                    <IconButton
                      onClick={() => {
                        setOpenConfirmDialog(item);
                      }}
                    >
                      <DeleteRounded color={'error'}/>
                    </IconButton>
                  )}
                </Stack>
              </ListItem>
            </>
          );
        })}
      </List>

      {openConfirmDialog && (
        <Dialog
          open={true}
          onClose={() => {
            setOpenConfirmDialog(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {'Are you sure you want to delete it?'}
          </DialogTitle>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenConfirmDialog(false);
              }}
            >
              Cancel
            </Button>
            <LoadingButton
              loading={loadingButton}
              variant={'contained'}
              color={'error'}
              onClick={() => {
                const deletedRow = {...openConfirmDialog};
                setLoadingButton(true);
                filesSchema.client
                  .delete(deletedRow.id as number, {id: deletedRow.id})
                  .then((res: any) => {
                    toast.success(`Successfully deleted ${schema.name}: ${
                      deletedRow?.name ? deletedRow?.name : deletedRow?.id
                    }`);
                    setOpenConfirmDialog(false);

                    fetchManualConfirmations();

                  })
                  .catch((e: any) => {
                    toast.error(`Error: Unable to delete file: ${
                      deletedRow?.name ? deletedRow?.name : deletedRow?.id
                    }`);
                  }).finally(() => {
                  setLoadingButton(false);
                });
              }}
              autoFocus
            >
              Delete
            </LoadingButton>
          </DialogActions>
        </Dialog>
      )}


    </>
  );
};

FileField.includes = (query: any, value: any) => true;

FileField.comparator = () => 0;

FileField.FilterRenderer = TimeFilter;
